export default __webpack_public_path__ + "static/media/gallery_02.4b04b095.jpg";